export const HeaderHeight = "95px";

// Dark
export const ThemeA = {
  palette: {
    common: {
      mainBackground: "#171717",
      background: "#1E2027",
      text: {
        primary: "#FFFFFF",
        secondary: "#ececec",
      },
      border: {
        dark: "#2c2c38",
      },
    },
    card: {
      background: {
        primary: "#1E2027",
        secondary: "#171717",
      },
      text: {
        primary: "#27DEBF",
      },
      boxShadow: {
        primary: "#00000052",
      },
    },
    text: {
      primary: "#fff",
      secondary: "#636880",
    },
  },
  typography: {
    text1: "1.6rem",
  },
};

// Light
export const ThemeB = {
  palette: {
    common: {
      mainBackground: "#F4F4FE",
      background: "#FFFFFF",
      text: {
        primary: "#171717",
        secondary: "#606060",
      },
      border: {
        dark: "#eeeeee",
      },
    },
    card: {
      background: {
        primary: "#F4F4FE",
        secondary: "#FFFFFF",
      },
      text: {
        primary: "#FF0961",
      },
      boxShadow: {
        primary: "#D6D6E1BD",
      },
    },
    text: {
      primary: "#000",
      secondary: "#636880",
    },
  },
  typography: {
    text1: "1.6rem",
  },
};

//Drife theme
export const ThemeDrife = {
  palette: {
    common: {
      mainBackground: "#0eaddf",
      background: "#FFFFFF",
      text: {
        primary: "#FFFFFF",
        secondary: "#606060",
      },
      border: {
        dark: "#eeeeee",
      },
    },
    card: {
      background: {
        primary: "#F4F4FE",
        secondary: "#FFFFFF",
      },
      text: {
        primary: "#FFFFFF",
      },
      boxShadow: {
        primary: "#D6D6E1BD",
      },
    },
    text: {
      primary: "#000",
      secondary: "#636880",
    },
  },
  typography: {
    text1: "1.6rem",
  },
};
